import { gql } from '@apollo/client';

export type AddressErrorType = 'HOUSE_NUM_MISMATCH' | 'INVALID_ADDRESS' | 'PRECISION_LACK' | 'OTHER';

export const ADDRESS_ERROR_HANDLE_FLAG = {
  UNHANDLED: 0,
  HANDLED_SUCCESS: 1,
  HANDLED_FAILED: 2,
} as const;

export interface AddressErrorRecordType {
  id: string;
  originalZipcode: string;
  originalState: string;
  originalCity: string;
  originalStreetAddress: string;
  originalBuilding?: string | null;
  originalFullAddress: string;
  addressId?: number | null;
  standardizedZipcode?: string | null;
  standardizedState?: string | null;
  standardizedCity?: string | null;
  standardizedStreetAddress?: string | null;
  standardizedFullAddress?: string | null;
  errorType?: string | null;
  handleFlag: number;
  handleResult?: string | null;
  remark?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressErrorRecordPageResponse {
  content: AddressErrorRecordType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressErrorRecordListResponse {
  addressErrorRecordList: AddressErrorRecordPageResponse;
}

export const GET_ADDRESS_ERROR_RECORD_LIST = gql`
  query GetAddressErrorRecordList(
    $originalZipcode: String
    $originalStreetAddress: String
    $errorType: String
    $handleFlag: Int
    $createdAtFrom: String
    $createdAtTo: String
    $page: Int!
    $size: Int!
  ) {
    addressErrorRecordList(
      originalZipcode: $originalZipcode
      originalStreetAddress: $originalStreetAddress
      errorType: $errorType
      handleFlag: $handleFlag
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      page: $page
      size: $size
    ) {
      content {
        id
        originalZipcode
        originalState
        originalCity
        originalStreetAddress
        originalBuilding
        originalFullAddress
        addressId
        standardizedZipcode
        standardizedState
        standardizedCity
        standardizedStreetAddress
        standardizedFullAddress
        errorType
        handleFlag
        handleResult
        remark
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const DELETE_ADDRESS_ERROR_RECORD = gql`
  mutation DeleteAddressErrorRecord($id: Long!) {
    deleteAddressErrorRecord(id: $id)
  }
`;

export const BATCH_DELETE_ADDRESS_ERROR_RECORD = gql`
  mutation BatchDeleteAddressErrorRecord($ids: [Long!]!) {
    batchDeleteAddressErrorRecord(ids: $ids)
  }
`;
